<template>
  <div class="app-change-payment-wrapper">
    <slot name="txtBefore"></slot>
    <div class="success-txt" v-if="view === 'viewPaymentWithSuccess'">
      <slot name="txtSuccess"></slot>
    </div>
    <PaymentInformation
      v-if="(view === 'viewPayment' || view === 'viewPaymentWithSuccess') && paymentInformation.paymentType !== null&& typeof paymentInformation.paymentType === 'object'"
      :payment="paymentInformation.paymentType">
      <template v-for="slot in possibleChildSlotsFor('ViewPayment')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </PaymentInformation>
    <div class="empty-txt" v-if="(view === 'viewPayment' || view === 'viewPaymentWithSuccess') && paymentInformation.paymentType === null">
      <slot name="txtIfEmpty"></slot>
    </div>
    <ChangePaymentData v-if="view === 'editPayment'"
      :credit-card-redirect-url="creditCardRedirectUrl"
      :credit-card-frame-address="creditCardFrameAddress"
      :payment.sync="paymentInformation_"
      :paymentInvalid.sync="paymentInvalid_"
      :process-name="'changePayment'"
      :noPaymentPossible="paymentInformation.paymentType !== null">
      <template v-for="slot in possibleChildSlotsFor('EditPayment')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ChangePaymentData>
    <Stepper v-if="view === 'editPayment'"
      :loading-next="loading"
      :show-prev="false"
      :show-next="true"
      :disabled-next="paymentInvalid_"
      @next="save()">
      <template v-for="slot in possibleChildSlotsFor('Stepper')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Stepper>
    <slot name="txtAfter"></slot>
  </div>
</template>

<script>
import PaymentInformation from '../../../generic/Payment/PaymentInformation.vue'
import ChangePaymentData from '@/components/process/FYVE/Payment/ChangePaymentData.vue'
import slotProxy from '@/mixins/slotProxy'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import transaction from '@/mixins/transaction'
import Stepper from '@/components/generic/Stepper.vue'

export default {
  name: 'ChangePaymentWrapper',
  data () {
    return {
      paymentInformation: {
        paymentType: {}
      },
      paymentInvalid_: true,
      paymentInformation_: {
        paymentType: 'bankAccount'
      },
      loading: false,
      currentCustomer: {
        lastName: '',
        firstName: ''
      }
    }
  },
  mounted () {
    this.changeToView()
    this.paymentInformation_ = {
      paymentType: 'bankAccount'
    }
  },
  mixins: [
    transaction('paymentInformation'),
    slotProxy()
  ],
  computed: {
    ...mapGetters('changePayment', {
      view: 'getView'
    })
  },
  components: {
    Stepper,
    PaymentInformation,
    ChangePaymentData
  },
  props: {
    creditCardFrameAddress: {
      type: String,
      required: true
    },
    creditCardRedirectUrl: {
      type: String
    }
  },
  methods: {
    ...mapMutations('changePayment', [
      'changeToViewWithSuccess',
      'changeToView'
    ]),
    ...mapActions('changePayment', [
      'changePayment'
    ]),
    async save () {
      this.loading = true
      this.paymentInformation_.owner = this.currentCustomer.firstName + ' ' + this.currentCustomer.lastName
      await this.changePayment({ changePaymentData: this.paymentInformation_ })
      await this.refreshQuery()
      this.changeToViewWithSuccess()
      this.loading = false
      this.paymentInformation_ = {
        paymentType: 'bankAccount'
      }
      this.paymentInvalid_ = true
    },
    refreshQuery () {
      this.$apollo.queries.paymentInformation.refetch()
    }
  },
  apollo: {
    paymentInformation: function () {
      return wrapQuery(
        gql`query paymentInformation{
          paymentInformation {
            paymentType {
              ...on BankAccount {
                type
                iban
                owner
              }
              ...on CreditCard {
                type
                holder
                company
                expiryMonth
                expiryYear
                lastDigits
              }
            }
          }
        }`, this, 'paymentInformation'
      )
    },
    currentCustomer: function () {
      return wrapQuery(gql`query personalData{
            currentCustomer {
            firstName,
            lastName
          }
        }`, this, 'currentCustomer'
      )
    }
  }
}
</script>
